import { useLocale } from 'src/lib/hooks/useLocal'
import { ArrowRight } from 'react-feather'
import Link from 'next/link'

const CODAvailability = () => {
  const { t } = useLocale()

  return (
    <div className='flex justify-between items-center py-4'>
      <div className='flex flex-row justify-between'>
        <div className='flex flex-col gap-2 text-sm'>
          <h2 className='font-medium text-carbon'>{t('cod_availability_additional_charges')}</h2>
          <p className='font-normal leading-5 text-gray-dark'>{t('cod_availability_additional_charges_description')}</p>
        </div>
      </div>
      <Link
        href='/shipping-delivery'
        className='flex items-center gap-1 text-sm font-semibold max-h-9 cursor-pointer p-2 rounded-lg border-1 hover:ring-2 hover:ring-coal-lighter  transition-all duration-200'
      >
        {t('manage_shipping_profiles')}
        <ArrowRight className='w-4 h-4' />
      </Link>
    </div>
  )
}

export default CODAvailability
